const PARTNER_CODE_KEY = 'partnerCode';

export const rememberPartnerCode = (code: string | null): void => {
    if (!code) {
        return;
    }

    try {
        sessionStorage.setItem(PARTNER_CODE_KEY, code);
    } catch {
        return;
    }
};

export const getPartnerCode = (): string | null => {
    try {
        return sessionStorage.getItem(PARTNER_CODE_KEY);
    } catch {
        return null;
    }
};
